import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InternalApiUrls } from '../utility/apiurls-internal';
import { DocumentMetadata } from './document-metadata';
import { ExternalApiUrls } from '../utility/apiurls-external';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentViewerService {
  private httpClient = inject(HttpClient);
  private internalApiUrls = inject(InternalApiUrls);
  private externalApiUrls = inject(ExternalApiUrls);
  private environmentService = inject(EnvironmentService);

  
 

  

  getDocumentMetadata(documentId: number): Observable<DocumentMetadata> {
    return this.httpClient.get<DocumentMetadata>(
      this.environmentService.isExternalSite
        ? this.externalApiUrls.document.metadata(documentId)
        : this.internalApiUrls.document.metadata(documentId),
    );
  }

  getDocumentPreview(documentId: number, index: number): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(
      this.environmentService.isExternalSite
        ? this.externalApiUrls.document.preview(documentId, index)
        : this.internalApiUrls.document.preview(documentId, index),
      {
        responseType: 'blob',
        observe: 'response',
      },
    );
  }
}
